import { Box, Stack, Typography } from '@mui/joy';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { Color, Direction, Level, Variant } from 'theme/enums';

const POPOVER_WIDTH = 320;
const POPOVER_Z_INDEX = 20;

interface IProps {
  children: ReactNode;
  showReset?: boolean;
  onReset?: () => void;
}

export const FiltersPopover = ({ children, showReset = false, onReset }: IProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 'calc(100% + 4px)',
        left: 0,
        width: POPOVER_WIDTH,
        zIndex: POPOVER_Z_INDEX,
        backgroundColor: 'background.surface',
        border: '1px solid',
        borderColor: 'neutral.300',
        borderRadius: '6px',
        boxShadow: 'md',
        padding: 2,
      }}
    >
      <Stack spacing={2}>
        <Stack
          direction={Direction.ROW}
          sx={{ alignItems: 'center', justifyContent: 'space-between' }}
        >
          <Typography level={Level.TITLE_MD}>{t('headerFilters')}</Typography>

          {showReset && (
            <Button
              color={Color.DANGER}
              variant={Variant.PLAIN}
              text={t('buttonLabelResetAll')}
              onClick={onReset}
            />
          )}
        </Stack>

        {children}
      </Stack>
    </Box>
  );
};
